import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import PartDetailsModelDesktop from './PartDetailsModelDesktop';
import {
  cartActions,
  cartDeliverLocationCodeSel,
  cartDeliverMethodSel,
  cartDeliveryLocationSel,
  cartItemCountSel
} from 'src/store/modules/cart';
import {
  warrantyActions,
  warrantyProvidersSel
} from 'src/store/modules/warranty';
import { IWarrantyProvider } from 'src/model/warranty.model';
import { userDataSel } from 'src/store/modules/user';

interface IStateFromProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  warranties: IWarrantyProvider[];
}

interface IDispatchFromProps {
  updateCart: () => void;
  getWarranties: () => void;
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  updateCart: () => dispatch(cartActions.getInfo()),
  getWarranties: () => dispatch(warrantyActions.getWarranty())
});

const mapStateToProps = (state: any) => ({
  showOnlyMSRP: state.msrp.showOnlyMSRP,
  isLoggedIn: state.signin.success,
  warranties: warrantyProvidersSel(state),
  cartDeliverLocationCode: cartDeliverLocationCodeSel(state),
  cartDeliverMethod: cartDeliverMethodSel(state),
  cartDeliverLocation: cartDeliveryLocationSel(state),
  cartItemsCount: cartItemCountSel(state),
  userData: userDataSel(state)
});

export const pureComponent = PartDetailsModelDesktop;
export default connect<IStateFromProps, IDispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(PartDetailsModelDesktop));
